export default __webpack_public_path__ + "static/media/hotdog.45a89767.jpeg";